export const AGE_RANGES = [
    { value: "0-5", label: "0–5 years" },
    { value: "6-12", label: "6–12 years" },
    { value: "13-17", label: "13–17 years" },
    { value: "18+", label: "18+ years" }
];

export const DISTANCE_OPTIONS = [
    { value: "5", label: "5 miles" },
    { value: "10", label: "10 miles" },
    { value: "25", label: "25 miles" },
    { value: "50", label: "50 miles" }
];

export const DAY_ABBREVIATIONS = [
    { value: "Sunday", label: "Sun" },
    { value: "Monday", label: "Mon" },
    { value: "Tuesday", label: "Tue" },
    { value: "Wednesday", label: "Wed" },
    { value: "Thursday", label: "Thu" },
    { value: "Friday", label: "Fri" },
    { value: "Saturday", label: "Sat" }
];
